import React from "react";
import ReactDOM from "react-dom/client";
const el = document.getElementById("root");
if (el) ReactDOM.createRoot(el).render(<React.StrictMode>{null}</React.StrictMode>);
